export default __webpack_public_path__ + "static/media/Left line.411b4858.svg";